import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController, Events } from 'ionic-angular';
import { TimelineService } from '../../../../../UI/src/app/shared/timeline/timeline.service';
import { JobAssessmentComponent } from '../job-search/components/job-assessment/job-assessment.component';
import { Storage } from '../../../../../UI/src/app/shared/constants';
import { DocumentUploadComponent } from '../candidate-profile/document-upload/document-upload.component';
import { AuthenticationService } from '../../../../../UI/src/app/shared/authentication/authentication.service';
import { SigninComponent } from '../../modules/authentication/components/signin/signin.component';
// import { ViewOfferDialogComponent } from './view-offer/view-offer-dialog.component';

@Component({
  selector: 'page-timeline',
  templateUrl: 'timeline.component.html'
})
export class TimelineComponent {
  tabSelected = 'all';
  allItems: any;
  timelineData = [];
  sortOptions: any;
  jobAssessmentComponent: any = JobAssessmentComponent;
  expand: boolean = false;
  navigatedFrom = '';
  selectedSortOption: any;
  sortType: string = 'asc';
  public loading = this.loadingCtrl.create();
  public isLoggedIn = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public timelineService: TimelineService,
    public loadingCtrl: LoadingController,
    public events: Events,
    public modalCtrl: ModalController,
    private authenticationService: AuthenticationService
  ) {
    this.navigatedFrom = navParams.get("navigatedFrom");

    this.events.subscribe('update-timeline-data', (data) => {
      this.getAllItems(true);
    });
    this.events.publish('showSiteMapNodes', true);
  }

  ionViewDidLoad() {
    if (!this.authenticationService.isUserLoggedin()) {
      this.navCtrl.setRoot(SigninComponent, {'redirectedFrom' : 'timeline'});
    }
    else {
      this.getAllItems(false);
    }
  }

  selectTab(tabID) {  
    this.sortOptions = this.timelineService.getCategorySortOptions(); 
    this.selectedSortOption = this.sortOptions.filter(Option => Option.key.indexOf('dueDate:asc') > -1)[0].key;
    if (tabID !== this.tabSelected) {
      this.closeDropdown();
      this.tabSelected = tabID;
      if (tabID === 'all') {
        this.timelineData = this.timelineService.getTimelineItems('ALL');
      }
      else if (tabID === 'interviews') {
        this.timelineData = this.timelineService.getTimelineItems('INTERVIEWS');
        this.selectedSortOption = this.sortOptions.filter(Option => Option.key.indexOf('startDate:asc') > -1)[0].key;
        this.sortOptions = this.sortOptions.filter(Option => Option.key.indexOf('activityType') === -1 &&
        Option.key.indexOf('dueDate') === -1);
      }
      else if (tabID === 'messages') {
        this.timelineData = this.timelineService.getTimelineItems('MESSAGES');
      }
      else {
        this.timelineData = this.timelineService.getTimelineItems('CAREER_TASKS');
      }
      this.sortTimelineElements();
    }
}

  onRefresh() {
    // Refresh will be implemented in 17.2 with real data
    this.getAllItems(true);
  }

  sortTimelineElements() {
    const sortOptionKey = this.sortOptions.filter(Option => Option.key === this.selectedSortOption)[0].key;
    const sort = sortOptionKey.split(":");
    this.sortType = sort[2];
    this.timelineData = this.timelineService.applySortFilter(this.selectedSortOption, this.timelineData);
  }

  getAllItems(forceRefresh: boolean) {
    this.loading.present();
    var tabKey = this.tabSelected;
    this.tabSelected = null;
    this.timelineService.fetchTimelineData(forceRefresh).then((res) => {
      if (res == true) {
        this.selectTab(tabKey);
        this.loading.dismiss();
      }
    });
  }

  onBtnClick() {
    this.expand = !this.expand;
  }

  closeDropdown() {
    this.expand = false;
    // This will preventdefault with the click event.
    return false;
  }
  
  OnClick(action,f){
    if (action.actionType === 'NAVIGATE_TO_URL' && action.properties[0] === 'OFFERLETTER') {
      if (action.properties[1] === '') {
        const offerUrl =  window.localStorage.getItem(Storage.DATASTORE) + 'FileAssets/' + f;
        // this.timelineService.fileUrl=offerUrl;
        // const uploadModal = this.modalCtrl.create(ViewOfferDialogComponent);//,null, { cssClass: "modal-fullscreen" });
        // uploadModal.present();
        window.open(offerUrl, '_blank');
      }
      else {
        window.open(action.properties[1], '_blank');
      }
    }
    else if (action.actionType === 'NAVIGATE_TO_URL' && action.properties[0] === 'DOCREQUEST') {
      this.navCtrl.setRoot(DocumentUploadComponent, { 'Id': action.properties[1] });
    }
    else {
      this.navCtrl.push(JobAssessmentComponent, { "assessmentId": action.properties[1], "navigatedFrom": this.navigatedFrom == undefined ? 'timeline' : this.navigatedFrom, "applicationId": action.properties[2], "isAssessment": true });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/timeline/timeline.component.ts